/**
 * ABWIN Scratch Popup — Discount Logic
 * ---------------------------------------------------------------
 * Returns the configured discount (see snippets/abwin-scratch-config.liquid
 * for the real, active Shopify discount code this points at).
 */
(function (global) {
  "use strict";

  const cfg = global.ABWIN_POPUP_CONFIG;

  const AbwinDiscount = {
    getDiscount() {
      return {
        code: cfg.discount.code,
        percent: cfg.discount.percent,
        label: cfg.discount.label,
        isTestMode: cfg.discount.isTestMode,
      };
    },
  };

  global.AbwinDiscount = AbwinDiscount;
})(window);
